module.exports = __webpack_public_path__ + "static/img/userImg.8d6849e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/userImg.png
// module id = cJyB
// module chunks = 1